<template>
  <div>
    <h1 class="page-title text-left">Landing Rate</h1>
    <div class="panel">
      <div class="panel-heading">
        <h3 class="panel-title">
          Details
          <router-link :to="{ name: 'data-landing-rates' }" class="pull-right ml-10"><i class="fa fa-list" title="Landing Rate List"></i></router-link>
          <i class="fa fa-pencil pointer pull-right" title="Edit" v-on:click="form.showEdit({id: id, list: true})"></i>
        </h3>
      </div>
      <div class="panel-body">
        <dl class="dl-horizontal">

          <dt>Site</dt>
          <dd>{{ siteName(form.data.siteId) }}</dd>

          <dt>Zone</dt>
          <dd>{{ zoneName(form.data.zoneId) }}</dd>

          <dt>Municipality</dt>
          <dd>{{ municipalityName(form.data.municipalityId) }}</dd>

          <dt>Observed</dt>
          <dd>{{ form.data.observedDate | date }} {{ form.data.observedTime | time }}</dd>

          <dt>Inspector</dt>
          <dd>{{ applicatorName(form.data.inspectorId) }}</dd>

          <dt>Duration (in minutes)</dt>
          <dd>{{ form.data.duration }}</dd>

          <dt>Mosquitoes</dt>
          <dd>
            <ul>
              <li v-for="mosquito in form.data.landingRateMosquitoes">
                {{ mosquito.mosquitoSpecyId ? mosquitoName(mosquito.mosquitoSpecyId) : '?' }} ({{ mosquito.mosquitoCount }})
              </li>
            </ul>
          </dd>

          <dt>Weather</dt>
          <dd>{{ form.data.weather }}</dd>

          <dt>Work Status</dt>
          <dd>{{ form.data.workStatus }}</dd>

        </dl>
      </div>
    </div>

    <site-form :form="form"></site-form>


  </div>
</template>

<script>
  import LandingRatesService from '@/services/LandingRatesService';
  import Form from '@/utils/form';
  import loader from '@/utils/loader';
  import siteForm from '@/components/forms/landing_rate';

  import store from '@/store';

  export default {
    name: 'landing_rates_details',

    components: {
      siteForm
    },

    props: ['id'],

    data() {
      return {
        form: new Form(
          LandingRatesService,
          {
          })
      }
    },

    methods: {
      siteName(id) {
        return this.$store.getters.siteNameById(id);
      },
      municipalityName(id) {
        return this.$store.getters.municipalityNameById(id);
      },
      mosquitoName(id) {
        return this.$store.getters.mosquitoNameById(id);
      },
      applicatorName(id) {
        return this.$store.getters.applicatorNameById(id);
      },
      zoneName(id) {
        return this.$store.getters.zoneNameById(id);
      },
    },

    mounted() {

      loader.lookups()
        .then(() => {
          this.form.getDetails(this.id);
        });
    }

  }
</script>

<style lang="scss">

</style>
